import React from 'react'
import Box from '@material-ui/core/Box'
import { useInitialQueryStringParameters } from '../../lib/query-string'
import PageHeading from '../../components/page-heading'
import { ConsumerLoginButton, MobileAppLoginButton } from '../../components/login-actions'

const ConfirmAccountPage = () => {
  const { mobileAppSignUp } = useInitialQueryStringParameters()
  return (
    <Box mb={5}>
      <PageHeading
        heading="MyPGA Account Verification"
        subheading="Your account has been verified. Log in to continue."
      />
      {!mobileAppSignUp
        ? <ConsumerLoginButton
            fullWidth
            size="large"
            color="primary"
            variant="contained"
          >
            Log in
          </ConsumerLoginButton>
        : <MobileAppLoginButton
            fullWidth
            size="large"
            color="primary"
            variant="contained"
          >
            Log in
          </MobileAppLoginButton>
      }
    </Box>
  )
}

export default ConfirmAccountPage
